import { Field } from 'react-final-form';
import { Option } from 'util/Types';
import styles from './LabelOrSelectField.module.scss';
import { SelectField } from '../SelectField';
import { nonNull } from 'util/commons';

type LabelOrSelectFieldProps = {
  options: Option[];
  label: string;
  fieldName?: string;
  staticValue?: string;
};

const LabelOrSelectField = (props: LabelOrSelectFieldProps) => {
  return (
    <div className={styles.field}>
      <div className={styles.labelBox}>
        <div className={styles.label}>{props.label}</div>
      </div>
      <div className={styles.fieldBox}>
        {props.fieldName ? (
          <Field name={props.fieldName}>
            {({ input }) =>
              props.options?.length > 1 ? (
                <SelectField
                  name={nonNull(props.fieldName)}
                  onChange={input.onChange}
                  value={input.value}
                  options={props.options}
                  containerClassName={styles.selectField}
                  isDarkmode
                />
              ) : (
                <div className={styles.value}>
                  {props.options.find(({ value }) => value === input.value)
                    ?.label || input.value}
                </div>
              )
            }
          </Field>
        ) : (
          <div className={styles.value}>{props.staticValue}</div>
        )}
      </div>
    </div>
  );
};

export default LabelOrSelectField;
